import { render, staticRenderFns } from "./FormulaSection.vue?vue&type=template&id=9da1c41e&scoped=true"
import script from "./FormulaSection.vue?vue&type=script&lang=js"
export * from "./FormulaSection.vue?vue&type=script&lang=js"
import style0 from "./FormulaSection.vue?vue&type=style&index=0&id=9da1c41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da1c41e",
  null
  
)

export default component.exports